import RecordBase from './Base';
import { useTranslation } from 'react-i18next';
import dig from 'object-dig';

export default class DoctorScheduleRecord extends RecordBase {
  static defaultAttributes = {
    doctor: null,
    begin_date: null,
    end_date: null,
    begin_time: null,
    end_time: null,
    is_closed: false,
    is_sunday: true,
    is_monday: true,
    is_tuesday: true,
    is_wednesday: true,
    is_thursday: true,
    is_friday: true,
    is_saturday: true,
    created_at: '',
    updated_at: '',
  };

  static _attributeNames = null;

  static get attributeNames(){
    const { t } = useTranslation();
    const trAttr = (attr) => t(`doctor_schedules.attributes.${attr}`);
    if(!this._attributeNames){
      this._attributeNames = {
        doctor:      trAttr('doctor'),
        begin_date:  trAttr('begin_date'),
        end_date:    trAttr('end_date'),
        begin_time:  trAttr('begin_time'),
        end_time:    trAttr('end_time'),
        is_closed:   trAttr('is_closed'),
        is_sunday: trAttr('is_sunday'),
        is_monday: trAttr('is_monday'),
        is_tuesday: trAttr('is_tuesday'),
        is_wednesday: trAttr('is_wednesday'),
        is_thursday: trAttr('is_thursday'),
        is_friday: trAttr('is_friday'),
        is_saturday: trAttr('is_saturday'),
        created_at:  trAttr('created_at'),
        updated_at:  trAttr('updated_at'),
      };
    }
    return this._attributeNames;
  }

  toParams(attrs={}){
    const {
      doctor,
      begin_date,
      end_date,
      begin_time,
      end_time,
      is_closed,
      is_sunday,
      is_monday,
      is_tuesday,
      is_wednesday,
      is_thursday,
      is_friday,
      is_saturday,
      created_at,
      updated_at,
    } = this.toObject();
    return {
      data:{
        attributes:{
          doctor_id: dig(doctor, 'id'),
          begin_date,
          end_date,
          begin_time,
          end_time,
          is_closed,
          is_sunday,
          is_monday,
          is_tuesday,
          is_wednesday,
          is_thursday,
          is_friday,
          is_saturday,
          created_at,
          updated_at,
          ...attrs
        }
      }
    };
  }
}
